"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logRocketTrack = logRocketTrack;

var _logRocketCookieUtils = require("./logRocketCookieUtils");

var _storage = require("../storage");

function logRocketTrack(eventName) {
  var logRocketActive = (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE);

  if (logRocketActive) {
    if (typeof window !== 'undefined' && window.LogRocket) {
      window.LogRocket.track(eventName);
    }
  }
}